import { GetProductDetailById } from "../../Services/MainServices";

export const PRODUCT_DETAIL_REQUEST = "PRODUCT_DETAIL_REQUEST";
export const PRODUCT_DETAIL_SUCCESS = "PRODUCT_DETAIL_SUCCESS";
export const PRODUCT_DETAIL_FAILURE = "PRODUCT_DETAIL_FAILURE";

export const fetchProductDetail = (pro_id) => async (dispatch) => {
  dispatch({ type: PRODUCT_DETAIL_REQUEST });

  try {
    const response = await GetProductDetailById(pro_id);
    // console.log("Response :", response.data)
    if (response.status === 200) {
      dispatch({ type: PRODUCT_DETAIL_SUCCESS, payload: response.data });
    } else {
      dispatch({ type: PRODUCT_DETAIL_FAILURE, payload: "Product not found" });
    }
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAIL_FAILURE,
      payload: error.response?.data || error.message,
    });
  }
};
